import { queryOptions, useQuery } from '@tanstack/react-query';
import { api } from '@/api';
import { PaginatedHomeLocationListFilters } from '@/api/apis/facilities/homelocation';
import { queryClient } from '@/queries';
import { homeLocationsQueryKeys } from '@/queries/homelocation/homelocation.keys';

const seedHomeLocations = async (params: PaginatedHomeLocationListFilters) => {
  const response = await api.homelocation.getHomeLocationsList(params);

  response.items.forEach((item) => {
    queryClient.setQueryData(homeLocationsQueryKeys.getItem(item.id), item);
  });

  return response;
};

export const getHomeLocationByIds = async (locationList: string[]) => {
  const homeLocationIdsSet = new Set(locationList);
  const ids = Array.from(homeLocationIdsSet).filter(Boolean).join(',');

  if (ids) {
    return seedHomeLocations({
      ids,
      pageIndex: 0,
      itemsPerPage: homeLocationIdsSet.size,
    });
  }

  return null;
};

export const homeLocationQueries = {
  list: (params: PaginatedHomeLocationListFilters) =>
    queryOptions({
      queryKey: homeLocationsQueryKeys.getList(params),
      queryFn: () => seedHomeLocations(params),
      staleTime: Infinity,
    }),
  item: (id: string) =>
    queryOptions({
      queryKey: homeLocationsQueryKeys.getItem(id),
      queryFn: () => api.homelocation.getHomeLocation(id),
      enabled: !!id,
      staleTime: Infinity,
    }),
};

const useHomeLocationQuery = (id?: string) => {
  return useQuery(homeLocationQueries.item(id || ''));
};

export { useHomeLocationQuery };
